// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-background-color: #004D40;
  --text-color: #ffffff;
  --link-hover-color: #A5D6A7;
}

.footer {
  background-color: var(--footer-background-color);
  color: var(--text-color);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px 80px;
  flex-wrap: wrap;
  border-top-left-radius: 20px; 
  border-top-right-radius: 20px;
}

.footer-left {
  max-width: 300px;
}

.footer-logo {
  width: 150px;
  margin-bottom: 15px;
}

.footer-description {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

.footer-founder {
  font-size: 14px;
  font-weight: bold;
}

.footer-copyright {
  font-size: 12px;
  margin-top: 10px;
  opacity: 0.8;
}

.footer-middle {
  display: flex;
  gap: 50px;
}

.footer-column {
  text-align: left;
}

.footer-heading {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column ul li {
  margin-bottom: 8px;
}

.footer-column ul li a {
  text-decoration: none;
  color: var(--text-color);
  font-size: 14px;
  transition: color 0.3s;
}

.footer-column ul li a:hover {
  color: var(--link-hover-color);
}

.footer-right {
  text-align: right;
}

.footer-social-icons {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.social-icon {
  color: var(--text-color);
  font-size: 24px;
  transition: color 0.3s ease;
}

.social-icon:hover {
  color: var(--link-hover-color);
}`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[":root {\n  --footer-background-color: #004D40;\n  --text-color: #ffffff;\n  --link-hover-color: #A5D6A7;\n}\n\n.footer {\n  background-color: var(--footer-background-color);\n  color: var(--text-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 40px 80px;\n  flex-wrap: wrap;\n  border-top-left-radius: 20px; \n  border-top-right-radius: 20px;\n}\n\n.footer-left {\n  max-width: 300px;\n}\n\n.footer-logo {\n  width: 150px;\n  margin-bottom: 15px;\n}\n\n.footer-description {\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n.footer-founder {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.footer-copyright {\n  font-size: 12px;\n  margin-top: 10px;\n  opacity: 0.8;\n}\n\n.footer-middle {\n  display: flex;\n  gap: 50px;\n}\n\n.footer-column {\n  text-align: left;\n}\n\n.footer-heading {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.footer-column ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-column ul li {\n  margin-bottom: 8px;\n}\n\n.footer-column ul li a {\n  text-decoration: none;\n  color: var(--text-color);\n  font-size: 14px;\n  transition: color 0.3s;\n}\n\n.footer-column ul li a:hover {\n  color: var(--link-hover-color);\n}\n\n.footer-right {\n  text-align: right;\n}\n\n.footer-social-icons {\n  display: flex;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.social-icon {\n  color: var(--text-color);\n  font-size: 24px;\n  transition: color 0.3s ease;\n}\n\n.social-icon:hover {\n  color: var(--link-hover-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
